module.exports = __webpack_public_path__ + "static/img/day_nick.3aaa338.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/features/authentication/static/day_nick.png
// module id = 2343
// module chunks = 61